import * as React from "react";
import { forwardRef } from "react";
const SvgParallelogram = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 14, viewBox: "0 0 20 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.6863 2.08952C5.84781 1.73073 6.2047 1.5 6.59817 1.5H17.4532C18.1789 1.5 18.663 2.24873 18.3651 2.91048L14.3137 11.9105C14.1522 12.2693 13.7953 12.5 13.4018 12.5H2.5468C1.82109 12.5 1.33704 11.7513 1.63493 11.0895L5.6863 2.08952Z", stroke: "#2B2B35", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgParallelogram);
export { ForwardRef as ReactComponent };
